import axiosPost from "./axiosPost";

export const RNHAreaGet = async (credentials, data) => {
    const body = {
        service: "RNHAreaGet",
        params: {
            rnhAreaId: data?.areaId || null,
            rnhZonaId: data?.zonaId || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
